import { render, staticRenderFns } from "./ModalAdd.vue?vue&type=template&id=3d73a44c&scoped=true"
import script from "./ModalAdd.vue?vue&type=script&lang=js"
export * from "./ModalAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d73a44c",
  null
  
)

export default component.exports